/**
 * Created by filatov on 28.10.2015.
 */
import $ from 'jquery'
import ReportChartUtils from './ReportChartUtils'

export default function ChartColorSelector(){}

ChartColorSelector.prototype.init = function(selectorDivId, selectorColorPanel, chartColorId, changesCallback){
    this.iconSelectorPanel = selectorColorPanel;
    if (changesCallback)
        this.changesCallback = changesCallback;


    const self = this;
    this.selectorDiv = document.getElementById(selectorDivId);
    $( this.selectorDiv  ).empty();
    this.selectorDiv .className = "chartColorSelector";

    const requestColorDiv = document.createElement("div");
    requestColorDiv.className = "requestColorDiv";
    this.requestColorDiv = $(requestColorDiv);
    this.selectorDiv .appendChild(requestColorDiv);

    const arrowDiv = document.createElement("div");
    arrowDiv.className = "arrowDiv";
    this.selectorDiv .appendChild(arrowDiv);

    this.setColor(chartColorId);
    this.selectorDiv.onclick = function () {self.updateOpenState(true); self.iconSelectorPanel.initAndShow( self.selectedColorId, self.selectorDiv,
                                                                            function () { self.handlePanelClicking(self.iconSelectorPanel.getColorId()) } ) };
    return this;
};

ChartColorSelector.prototype.getColorId = function(){
    return this.selectedColorId;
};

ChartColorSelector.prototype.setColor = function(backgroundColorId){
    this.selectedColorId = backgroundColorId;
    $(this.requestColorDiv).css("background-color", ReportChartUtils.getChartColorSchemeById(this.selectedColorId).singleColumn);
};

ChartColorSelector.prototype.handlePanelClicking = function ( backgroundColor ) {
    this.setColor(backgroundColor);
    if(this.changesCallback)
        this.changesCallback();
};

ChartColorSelector.prototype.updateOpenState = function(isOpen){
     $(this.selectorDiv).toggleClass("open", isOpen);
};




// WEBPACK FOOTER //
// ./web/js/reports/ChartColorSelector.js